import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { ComponentProps } from 'lib/ComponentProps';

import { Button } from 'src/components/basicContent/_Button/Button';
import { Modal } from 'src/components/basicContent/_Modal/Modal';
import SearchBar from 'src/components/search/SearchBar/SearchBar';

import HamburgerSvg from 'public/icons/hamburger.svg';
import SearchSvg from 'public/icons/search.svg';

import { HeaderFields } from '../HeaderFields';
import { NavigationMenu } from '../NavigationMenu';

import HamburgerMenu from './_HamburgerMenu/_HamburgerMenu';
import LoggedOutButtons from './_LoggedOutButtons/_LoggedOutButtons';
import WelcomeDropdown from './_WelcomeDropdown/_WelcomeDropdown';

import styles from './_AccessLevelMenus.module.css';

export type AccessLevelMenuProps = ComponentProps & {
	fields: HeaderFields & {
		NavigationMenu: NavigationMenu;
	};
};

export function AccessLevelMenus(props: AccessLevelMenuProps): JSX.Element {
	const router = useRouter();
	const RcnUser = useContext(RcnUserContext);

	const [menuState, setMenuState] = useState(false);
	const [searchModalState, setSearchModalState] = useState(false);

	useEffect(() => {
		function handleRouteChange() {
			setSearchModalState(false);
		}
		router.events.on('routeChangeComplete', handleRouteChange);
		return () => router.events.off('routeChangeComplete', handleRouteChange);
	}, [router.events]);

	return (
		<section>
			<div className={styles.mobileButtons}>
				<Button
					title={props.fields?.MobileMenuTitle?.value}
					className={`buttonReset ${styles.searchBtn}`}
					onClick={() => setSearchModalState(true)}
				>
					<SearchSvg />
				</Button>

				<Button
					title={props.fields?.MobileMenuTitle?.value}
					className={`buttonReset ${styles.hamburgerBtn}`}
					onClick={() => setMenuState(true)}
				>
					<HamburgerSvg />
				</Button>
			</div>

			<div className={styles.loggedOutButtons}>
				<LoggedOutButtons fields={props.fields} authenticatedUserProfile={RcnUser.authenticatedUserProfile} />
			</div>

			<WelcomeDropdown fields={props.fields} authenticatedUserProfile={RcnUser.authenticatedUserProfile} />

			<HamburgerMenu
				fields={props.fields}
				authenticatedUserProfile={RcnUser.authenticatedUserProfile}
				menuState={menuState}
				setMenuState={setMenuState}
			/>

			<Modal modalState={searchModalState} setModalState={setSearchModalState}>
				<Text tag="h3" field={props.fields.SearchButtonText} className={styles.searchBarTitle} />
				<SearchBar {...props} fields={props.fields} integrated />
			</Modal>
		</section>
	);
}
